export default "__VITE_ASSET__CDLDGy3U__"